import { Box, Button, Fade } from '@mui/material'
import { CoreTypography } from '@thriveglobal/thrive-web-leafkit'
import { defineMessages, useIntl } from 'react-intl'

export type NoResultsMessageProps = {
    message?: string
    onRefetch?: () => void
}

const intlMessages = defineMessages({
    noResultsMessage: {
        defaultMessage: `You don't seem to have any results at the moment.
            Please check back soon!`,
        description: `A message displayed when a user cannot access their results`
    }
})

const NoResultsMessage: React.FC<NoResultsMessageProps> = ({
    message,
    onRefetch
}) => {
    const intl = useIntl()

    const noResultsMessage =
        message || intl.formatMessage(intlMessages.noResultsMessage)

    return (
        <Fade in>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    pt: 6
                }}
            >
                <CoreTypography variant="h3">{noResultsMessage}</CoreTypography>

                {onRefetch && (
                    <Button
                        sx={{ mt: 6 }}
                        size={'large'}
                        variant={'contained'}
                        onClick={() => {
                            onRefetch()
                        }}
                    >
                        <CoreTypography
                            variant="h5"
                            color="primary.contrastText"
                        >
                            {intl.formatMessage({
                                defaultMessage: 'Try Again',
                                description: `The user should repeat the action`
                            })}
                        </CoreTypography>
                    </Button>
                )}
            </Box>
        </Fade>
    )
}

export default NoResultsMessage
